import React, { useEffect, useState } from 'react';

const Cart = ({ size }) => (
  <svg viewBox="0 0 120 100" width={size} height={size * 0.83} fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 22h16l10 46h56l10-40H30" />
    <path d="M40 40h50M43 52h44" strokeWidth="6" strokeDasharray="8 8" />
    <g className="cart-wheel" style={{ transformOrigin: '42px 84px' }}><circle cx="42" cy="84" r="9" /><path d="M42 75v18M33 84h18" strokeWidth="4" /></g>
    <g className="cart-wheel" style={{ transformOrigin: '80px 84px' }}><circle cx="80" cy="84" r="9" /><path d="M80 75v18M71 84h18" strokeWidth="4" /></g>
  </svg>
);

// Minimum display time so the animation is perceptible even on instant loads.
export const useMinDelay = (loading, ms = 250) => {
  const [show, setShow] = useState(loading);
  useEffect(() => {
    if (loading) { setShow(true); return undefined; }
    const timer = setTimeout(() => setShow(false), ms);
    return () => clearTimeout(timer);
  }, [loading, ms]);
  return show;
};

const CartLoader = ({ label, size = 72, className = '', testId = 'cart-loader', tone = 'light' }) => (
  <div className={`flex flex-col items-center justify-center gap-3 ${tone === 'dark' ? 'text-gray-900' : 'text-white'} ${className}`} role="status" aria-live="polite" data-testid={testId}>
    <div className="cart-track" style={{ width: size * 3 }}>
      <div className="cart-roll"><Cart size={size} /></div>
      <div className="cart-ground" />
    </div>
    <div className="flex items-center gap-1.5 font-black tracking-tighter text-xl leading-none select-none">
      <span>DEAL</span><span className="text-[#E50914]">RUN</span>
      <span className="cart-dots ms-1 text-[#E50914]"><i /><i /><i /></span>
    </div>
    {label && <p className="text-xs text-[#808080]">{label}</p>}
  </div>
);

export default CartLoader;
